import type { ManualListingResult } from "../domain/manualListings";
import { ManualListingFlow } from "./manual-listing-flow";
export function ManualListingDialog({ itemIDs, initialAccountID, linkExisting, onClose, onDone }: {
  itemIDs: string[]; initialAccountID?: string; linkExisting?: boolean; onClose: () => void; onDone?: (result: ManualListingResult) => void;
}) {
  return <ManualListingFlow initialItemIDs={itemIDs} initialAccountID={initialAccountID} initialTask="record" linkExisting={linkExisting} onClose={onClose} onDone={onDone} />;
}
